// 呱呱爆料 —— 站点内容数据（栏目标签、头条、栏目素材、话题榜等）
// 注意：本站爆料内容均为虚构的娱乐资讯栏目示例，用于演示信息展示结构。

export const siteName = "呱呱爆料";

export const navLinks = [
  { key: "home", label: "首页", href: "#top" },
  { key: "headline", label: "今日猛料", href: "#headline" },
  { key: "exclusive", label: "独家首发", href: "#exclusive" },
  { key: "feed", label: "最新线索", href: "#feed" },
  { key: "topics", label: "热议话题", href: "#topics" },
  { key: "faq", label: "常见问题", href: "#faq" },
  { key: "about", label: "关于我们", href: "#about" },
];

export const categoryTags = [
  { key: "all", label: "全部线索" },
  { key: "leak", label: "内部流出" },
  { key: "debut", label: "首发曝光" },
  { key: "secret", label: "绝密文件" },
  { key: "rumor", label: "圈内传闻" },
];

export interface NewsItem {
  id: number;
  title: string;
  summary: string;
  tag: string;
  tagType: "leak" | "debut" | "secret" | "rumor";
  time: string;
  views: string;
  author: string;
  img: string;
}

export const breakingNews = [
  { id: 1, title: "某头部综艺筹备名单内部流出，多位常驻人选引粉丝热议", time: "12 分钟前" },
  { id: 2, title: "绝密文件显示：新片档期或提前官宣，主演阵容即将揭晓", time: "36 分钟前" },
  { id: 3, title: "圈内人士爆料：现象级热剧续集已进入剧本围读阶段", time: "1 小时前" },
  { id: 4, title: "首发曝光：跨界音乐企划神秘嘉宾名单初见端倪", time: "2 小时前" },
  { id: 5, title: "独家线索：某待播剧集海报被曝替换，片方暂无回应", time: "3 小时前" },
];

export const headlineStory = {
  title: "重磅独家｜一档跨年晚会的完整嘉宾方案，内部流出抢先看",
  lead: "距离跨年还有数月，一份疑似内部流出的晚会嘉宾编排方案已在圈内流传。呱呱爆料第一时间拿到部分关键截图，并逐条核对了网传名单与场次排布。",
  tag: "绝密文件",
  time: "今日 08:26",
  img: "https://readdy.ai/api/search-image?query=dark%20glamorous%20stage%20backstage%20scene%20with%20golden%20bokeh%20lights%20and%20smoke%2C%20silhouette%20of%20crew%20and%20equipment%2C%20cinematic%20warm%20amber%20tones%2C%20editorial%20mystery%20atmosphere%2C%20high%20detail%20photography&width=1600&height=900&seq=gua-headline-01&orientation=landscape",
};

export const hotColumns = [
  {
    id: 1,
    title: "内娱速递",
    desc: "聚焦头部艺人、热播剧与综艺的一线动态，优先呈现圈内人士提供的待确认线索。",
    count: 328,
    tagType: "leak",
    img: "https://readdy.ai/api/search-image?query=stylish%20television%20studio%20control%20room%20with%20screens%20and%20cameras%2C%20warm%20orange%20and%20cream%20tones%2C%20editorial%20documentary%20feel%2C%20soft%20cinematic%20lighting&width=800&height=600&seq=gua-col-leak-01&orientation=landscape",
  },
  {
    id: 2,
    title: "饭圈雷达",
    desc: "跟读粉丝社群的每一次风向，捕捉应援、物料与活动的首个真实信号。",
    count: 256,
    tagType: "rumor",
    img: "https://readdy.ai/api/search-image?query=large%20conference%20lightsticks%20and%20banners%20in%20a%20dark%20arena%2C%20warm%20neon%20amber%20glow%2C%20youthful%20energetic%20crowd%20atmosphere%2C%20cinematic&width=800&height=600&seq=gua-col-rumor-01&orientation=landscape",
  },
  {
    id: 3,
    title: "财经八卦",
    desc: "把娱乐圈与商业跨界的热点串起来，看资本与作品之间若隐若现的线索。",
    count: 187,
    tagType: "secret",
    img: "https://readdy.ai/api/search-image?query=abstract%20financial%20documents%20with%20golden%20lens%20flare%20and%20warm%20sepia%20tone%2C%20mystery%20and%20intrigue%2C%20editorial%20editorial%20photography%20soft%20focus&width=800&height=600&seq=gua-col-secret-01&orientation=landscape",
  },
  {
    id: 4,
    title: "全球瓜田",
    desc: "从好莱坞到韩国爱豆圈，跨国情报一次看全，第一手对外文化资讯。",
    count: 141,
    tagType: "debut",
    img: "https://readdy.ai/api/search-image?query=global%20city%20skyline%20at%20dusk%20with%20warm%20lights%20and%20film%20grain%2C%20editorial%20news%20montage%20vibe%2C%20rich%20amber%20and%20cream%20palette&width=800&height=600&seq=gua-col-debut-01&orientation=landscape",
  },
];

export const exclusiveStories = [
  {
    id: 1,
    title: "独家｜一档新观察综艺的飞行嘉宾排期，比官宣早了整整六周",
    desc: "呱呱爆料从制作团队外围拿到了一版飞行嘉宾排期表，其中出现多位从未被网传提及的名字，坐标时间均清晰可考。",
    tag: "独家首发",
    time: "今日",
    tagType: "debut",
    img: "https://readdy.ai/api/search-image?query=empty%20bright%20television%20studio%20set%20with%20colorful%20chairs%20and%20stage%20lights%20warming%20up%2C%20cream%20and%20amber%20palette%2C%20editorial%20production%20behind%20the%20scenes%20photo&width=900&height=640&seq=gua-excl-01&orientation=landscape",
  },
  {
    id: 2,
    title: "内部流出｜热播年代剧片场侧拍图，服装细节被考古粉逐帧比对",
    desc: "一组未经后期处理的片场侧拍流出，服装与道具的考究程度远超预期，细节党已经开始逐帧分析造型背后的年代密码。",
    tag: "内部流出",
    time: "昨日",
    tagType: "leak",
    img: "https://readdy.ai/api/search-image?query=retro%201990s%20chinese%20television%20period%20drama%20film%20set%20with%20vintage%20costume%20rack%20and%20warm%20amber%20lighting%2C%20cinematic%20editorial%20photography&width=900&height=640&seq=gua-excl-02&orientation=landscape",
  },
  {
    id: 3,
    title: "绝密文件｜一份被翻红的旧企划案，揭开顶流组合的出道故事",
    desc: "一份封存多年的初代企划文件被重新挖出，用文字还原了组合从海选到出道的每一个关键转折，比官方纪录片更细。",
    tag: "绝密文件",
    time: "2 天前",
    tagType: "secret",
    img: "https://readdy.ai/api/search-image?query=vintage%20paper%20documents%20and%20photographs%20arranged%20on%20a%20desk%20with%20warm%20desk%20lamp%20glow%2C%20nostalgic%20amber%20tone%2C%20mysterious%20archive%20storytelling%2C%20editorial&width=900&height=640&seq=gua-excl-03&orientation=landscape",
  },
  {
    id: 4,
    title: "圈内传闻｜某音乐节压轴人选摇摆不定，主办方连夜开了三场会",
    desc: "距离官宣不到一周，网传压轴阵容仍有变数。呱呱爆料汇总了三方消息源的说法，帮你拼出最接近真相的一版。",
    tag: "圈内传闻",
    time: "3 天前",
    tagType: "rumor",
    img: "https://readdy.ai/api/search-image?query=massive%20outdoor%20music%20festival%20stage%20with%20lasers%20and%20warm%20amber%20lights%2C%20crowd%20silhouettes%2C%20cinematic%20energetic%20atmosphere&width=900&height=640&seq=gua-excl-04&orientation=landscape",
  },
];

export const feedNews: NewsItem[] = [
  {
    id: 1,
    title: "网传某古装剧第二季已在筹备，多位主角回归，片酬谈判陷入拉锯",
    summary: "据制作组外围消息，第二季世界观将大幅扩展。多位主演对剧本方向存在分歧，开机时间仍未敲定。",
    tag: "圈内传闻",
    tagType: "rumor",
    time: "18 分钟前",
    views: "1.2万",
    author: "瓜田小队长",
    img: "https://readdy.ai/api/search-image?query=ancient%20chinese%20costume%20drama%20film%20location%20with%20pavilions%20and%20warm%20sunset%2C%20cinematic%20amber%20and%20cream%20tones%2C%20editorial&width=600&height=440&seq=gua-feed-01&orientation=landscape",
  },
  {
    id: 2,
    title: "独家｜偶像男团新专辑主打曲目单流出，含两首此前未曝光 Demo",
    summary: "一支 Demo 的片段在粉丝间流传，编曲风格较上一张有明显突破，录音室版本完成度较高。",
    tag: "独家首发",
    tagType: "debut",
    time: "52 分钟前",
    views: "9860",
    author: "前线情报站",
    img: "https://readdy.ai/api/search-image?query=modern%20recording%20studio%20with%20microphone%20and%20sound%20dampening%20panels%2C%20warm%20amber%20led%20lighting%2C%20cinematic%20editorial&width=600&height=440&seq=gua-feed-02&orientation=landscape",
  },
  {
    id: 3,
    title: "内部流出｜一线花旦后续电影资源盘点，经纪团队深夜开会引关注",
    summary: "多份业内规划被指流出，平台方资源绑定成为焦点，知情人士称双方仍在博弈阶段。",
    tag: "内部流出",
    tagType: "leak",
    time: "1 小时前",
    views: "7640",
    author: "娱记小鱼",
    img: "https://readdy.ai/api/search-image?query=elegant%20red%20carpet%20backstage%20with%20blurred%20lights%20and%20warm%20glow%2C%20cinematic%20glamorous%20mystery%20mood%2C%20amber%20and%20cream&width=600&height=440&seq=gua-feed-03&orientation=landscape",
  },
  {
    id: 4,
    title: "绝密文件｜已故音乐人未公开手稿被整理，或收录进纪念精选集",
    summary: "一份整理中的手稿目录近期曝光，多为早期创作笔记，团队正评估是否纳入纪念企划。",
    tag: "绝密文件",
    tagType: "secret",
    time: "2 小时前",
    views: "5320",
    author: "档案管理员",
    img: "https://readdy.ai/api/search-image?query=handwritten%20music%20manuscript%20sheet%20music%20with%20pencil%20notes%20under%20warm%20light%2C%20nostalgic%20editorial%20photography%2C%20amber%20sepia&width=600&height=440&seq=gua-feed-04&orientation=landscape",
  },
];

export const topicRank = [
  { rank: 1, title: "#顶流组合再合体#", hot: 98.6, delta: "up" },
  { rank: 2, title: "#热播剧续集#", hot: 92.3, delta: "up" },
  { rank: 3, title: "#跨年晚会名单#", hot: 87.1, delta: "up" },
  { rank: 4, title: "#新综嘉宾#", hot: 79.4, delta: "new" },
  { rank: 5, title: "#年代剧细节#", hot: 71.8, delta: "flat" },
  { rank: 6, title: "#音乐节压轴#", hot: 66.2, delta: "down" },
];

export const faqList = [
  {
    q: "呱呱爆料的信息来源可靠吗？",
    a: "呱呱爆料的线索大多来自圈内人士、粉丝社群与公开流出的物料，我们会对每条信息进行多方交叉比对，并在内容中明确标注“待确认”程度，帮助你在追瓜时保持判断。",
  },
  {
    q: "“内部流出”“首发曝光”和“绝密文件”有什么区别？",
    a: "“内部流出”指来自制作或经纪团队内部、尚未官宣的物料；“首发曝光”是呱呱爆料在全网率先发布的内容；“绝密文件”则指年代较久、此前未被系统整理过的资料或档案。三类内容都经过脱敏处理，不涉及未公开的个人隐私。",
  },
  {
    q: "如何判断一条爆料是真的？",
    a: "你可以关注三点：信息源是否多元、是否有可交叉验证的细节、发布方是否标注了确认状态。呱呱爆料会为存疑内容打上“传闻”标签，并持续跟进后续官宣进展。",
  },
  {
    q: "爆料内容会不会侵犯艺人隐私？",
    a: "不会。呱呱爆料仅呈现公开场合、公开播出内容及行业工作信息，对涉及个人生活、住址等隐私细节一律做模糊化处理，遵守内容与隐私相关规范。",
  },
  {
    q: "我发现了独家线索，可以投稿吗？",
    a: "当然可以！欢迎在下方“我要爆料”表单提交线索，留下尽可能多的细节。呱呱爆料团队会优先核实高价值线索，并在确认后第一时间跟进。",
  },
];

export const stats = [
  { value: "380万+", label: "月度吃瓜读者" },
  { value: "12万+", label: "累计爆料线索" },
  { value: "98%", label: "官宣验证率" },
  { value: "24h", label: "热点跟进速度" },
];